import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ApiError } from '@/lib/http';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message?: string;
}

let seq = 0;

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);

  function push(kind: Toast['kind'], title: string, message?: string, timeoutMs = kind === 'error' ? 7000 : 4000) {
    const id = ++seq;
    toasts.value.push({ id, kind, title, message });
    setTimeout(() => dismiss(id), timeoutMs);
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return {
    toasts,
    dismiss,
    success: (title: string, message?: string) => push('success', title, message),
    info: (title: string, message?: string) => push('info', title, message),
    warning: (title: string, message?: string) => push('warning', title, message),
    error: (title: string, message?: string) => push('error', title, message),
    /** Shows an API error with its reference id so support can find it in the logs. */
    apiError: (err: unknown, fallback = 'Something went wrong') => {
      if (err instanceof ApiError) {
        push('error', err.message || fallback, err.traceId ? `Reference: ${err.traceId.slice(0, 8)}` : undefined);
      } else {
        push('error', fallback);
      }
    },
  };
});
